
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
    selector: 'education-information',
    templateUrl: './alumni-question.component.html'
})
export class AlumniQuestionComponent implements OnInit {
    @Input('data') inputConfig: any;
    @Input() public wcForm;
    @Input() removeEducationInfo: Function;
    @Input() eduInfoCount: any;

    constructor(
        public fb: FormBuilder,
    ) { }

    ngOnInit() {
    }

    removeEducationalInfo() {
        this.removeEducationInfo();
    }
}